module.exports = __webpack_public_path__ + "img/10979927_S.61a1887a.png";